import React, { Fragment, useEffect, useState } from "react";
import {
  Typography,
  Button,
  Grid,
  Box,
  TableContainer,
  Table,
  TableBody,
  TablePagination,
  FormHelperText,
  FormControl,
} from "@material-ui/core";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import InputMask from "react-input-mask";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import SearchIcon from "@material-ui/icons/Search";
import EditIcon from "@material-ui/icons/Edit";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import StoreMallDirectoryIcon from "@material-ui/icons/StoreMallDirectory";
import styles from "../../../../styles/global-styles";
import { ProductService } from "../../../../services/product.service";
import { connect } from "react-redux";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { actions } from "../../../../redux/actions/alert";
import AddAccesoryStockModal from "../../modals/AddAccesoryStockModal";
import ProductTableToolbar from "../../../shared/table/ProductTableToolbar";
import TableHeadProduct from "../../../shared/table/TableHeadProduct";
import { headCellAccesoryProduct } from "../../../stateless/headTables/HeadCellAccesoryProduct";
import AccesoryDetailRow from "../../../stateless/AccesoryDetailRow";
import GlobalEdition from "../../modals/GlobalEdition";
import DistributionDialog from "../../modals/DistributionDialog";
import { clickCheckbox, selectAllCheckbox } from "../../../../_utils/checkBox";
import { changeRowsPerPage } from "../../../../_utils/utils";
import ColorSelect from "../../../shared/selects/ColorSelect";
import SiteSelect from "../../../shared/selects/SiteSelect";

const rightButton = { ...styles.buttonRightHeader, marginRight: 30 };
const usetSyles = makeStyles((theme) => ({
  title: styles.title,
  subtitle: styles.subtitle,
  label: styles.label,
  rightButton,
  backgroundIcon: styles.backgroundIcon,
  link: styles.link,
  customSelect: styles.customSelect,
  table: {
    minWidth: 750,
  },
  rowSelected: {
    "&:hover": {
      backgroundColor: "#ccebff !important",
    },
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      width: "230px",
      maxWidth: 250,
    },
  },
}));

const AccesoryDetail = ({ brand, model, barCode, addAlert, detailAlert }) => {
  const classes = usetSyles();

  const [detailProduct, setDetailProduct] = useState({});
  const [openModal, setOpenModal] = React.useState({});
  const [queryParams, setqueryParams] = useState({
    brand,
    model,
    barCode,
    inDistribution: 0,
    productSold: 0,
  });
  const [accesoryProducts, setAccesoryProducts] = useState([]);
  const [checkProducts, setcheckProducts] = useState();
  /** Pagination */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  /**Check box options */
  const [selected, setSelected] = useState([]);
  const [errorObject, setErrorObject] = React.useState({
    showError: false,
    message: "",
  });
  const body = { brand, model, barCode, inDistribution: 0, productSold: 0 };
  useEffect(() => {
    loadAccesories();
  }, []);

  const loadAccesories = async () => {
    try {
      const { data } = await ProductService.getProductByAccesoriesWithParams(
        body
      );
      console.log("data accesory brand and model", data);
      /** Exist at least one accesory product  (created )in store */
      if (data.length && data[0]) {
        const {
          accesory: {
            id,
            brand,
            model,
            color,
            barCode,
            providerId,
            cost,
            price,
            discount,
            subcategory_type,
            provider,
            subcategoryTypeId,
          },
        } = data[0];
        const productId = data[0].id;
        setDetailProduct({
          ...detailProduct,
          productId,
          accesoryId: id,
          brand,
          model,
          color,
          barCode,
          providerId,
          cost,
          price,
          discount,
          name: subcategory_type.name || "No definido",
          providerName: provider.name,
          subcategoryTypeId,
        });
        setAccesoryProducts(data);
      } else {
        const errorObj = {
          noAvailable: "No hay productos en el almacén actualmente",
        };
        throw errorObj;
      }
    } catch (error) {
      console.log(error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: error.noAvailable ? "warning" : "error",
        message: error.noAvailable ? error.noAvailable : error.msgs,
      });
    }
  };

  const handleClickCheckbox = (movileId) => {
    console.log("movileId", movileId);
    console.log("items selected", clickCheckbox(movileId, selected));
    setSelected(clickCheckbox(movileId, selected));
  };

  const handleQuerySelected = (key, value) => {
    setqueryParams({ ...queryParams, [key]: value === "none" ? "" : value });
  };

  const searchProductByFilters = async () => {
    console.log("queryParams", queryParams);
    try {
      const { data } = await ProductService.getProductByAccesoriesWithParams(
        queryParams
      );
      console.log("data from filters response", data);
      if (data.length) setAccesoryProducts(data);
      else {
        addAlert({ showAlert: true });
        detailAlert({
          severity: "warning",
          message: "No se encontraron productos con los filtros seleccionados",
        });
      }
    } catch (error) {
      console.log(error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: error.msgs || "Error al procesar tu solicitud",
      });
    }
  };

  const handleOnClose = () =>
    setOpenModal({ ...openModal, open: false, option: undefined });

  const handleActionTrigered = (actionSucceed, actionMessage, option) => {
    addAlert({ showAlert: true });
    if (option === "stock") {
      handleOnClose();
    } else if (option === "update") {
      setSelected([]);
    }

    if (actionSucceed) {
      loadAccesories();
      detailAlert({
        severity: "success",
        message: actionMessage,
        time: 2000,
      });
    } else {
      console.log("message", actionMessage);
      detailAlert({
        severity: "error",
        message: actionMessage,
      });
    }
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleCheckAllProducts = () => {
    const accesoriesOnStore = accesoryProducts.filter(
      (item) => item.accesory.siteId === 1
    );
    if (checkProducts === "0") {
      setErrorObject({
        showError: true,
        message: "Escribir un número mayor a 0 ",
      });
      return;
    } else if (parseInt(checkProducts, 10) > accesoriesOnStore.length) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "warning",
        message: `Sólo se tienen disponibles ${accesoriesOnStore.length} accesorios en almacén. Modificar la cantidad a distribuir`,
        time: 4000,
      });
      return;
    } else {
      const idsArray = accesoriesOnStore.map((elem) => elem.accesoryId);
      console.log("idsArray", idsArray);
      setSelected(idsArray.slice(0, parseInt(checkProducts, 10)));
    }
  };

  const handleCheckInput = ({ target: { value } }) => {
    if (value !== 0) setErrorObject({ showError: false, message: "" });
    setcheckProducts(value);
  };

  return (
    <Fragment>
      <div style={{ display: "inline-flex" }}>
        <ArrowBackIosIcon color="primary" />
        <Typography variant="body1" component={"div"}>
          <Box mb={3}>
            {" "}
            <Link
              to="/dashboard/inventario/accesorios"
              className={classes.link}
            >
              Regresar
            </Link>
          </Box>
        </Typography>
      </div>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item>
          <Typography className={classes.subtitle}>
            Inventario{" "}
            {detailProduct && (
              <>
                {detailProduct.name} {brand} {model}
              </>
            )}
          </Typography>
        </Grid>

        <Grid item>
          <ColorSelect color={handleQuerySelected}></ColorSelect>
        </Grid>

        <Grid item>
          <SiteSelect site={handleQuerySelected} showNone />
        </Grid>
        <Grid item>
          <Button
            className={classes.rightButton}
            variant="contained"
            onClick={() => searchProductByFilters()}
            color="primary"
            endIcon={<SearchIcon color="secondary" />}
          >
            Filtrar
          </Button>
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        spacing={4}
        style={{ marginTop: 50, marginBottom: 10 }}
      >
        <Grid item>
          <Button
            className={classes.rightButton}
            onClick={() =>
              setOpenModal({ ...openModal, open: true, option: 1 })
            }
            disabled={!selected.length}
            variant="contained"
            color="primary"
            endIcon={<StoreMallDirectoryIcon color="secondary" />}
          >
            Distribución
          </Button>

          <Button
            disabled={!selected.length}
            className={classes.rightButton}
            onClick={() =>
              setOpenModal({ ...openModal, open: true, option: 3 })
            }
            variant="contained"
            color="primary"
            endIcon={<EditIcon color="secondary" />}
          >
            Edición global
          </Button>

          <Button
            className={classes.rightButton}
            onClick={() =>
              setOpenModal({ ...openModal, open: true, option: 2 })
            }
            variant="contained"
            color="primary"
            endIcon={<AddCircleIcon color="secondary"></AddCircleIcon>}
          >
            Nuevo stock
          </Button>
        </Grid>

        <ValidatorForm
          noValidate
          onKeyPress={(event) => {
            if (event.which === 13 /* Enter */) {
              event.preventDefault();
            }
          }}
          className={classes.form}
          method="GET"
          onSubmit={handleCheckAllProducts}
          onError={(errors) => {}}
        >
          <Grid item>
            <div style={{ display: "inline-flex" }}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              ></Typography>
              <FormControl error={errorObject.showError}>
                <InputMask
                  mask="999"
                  maskChar=""
                  style={{ maxWidth: 150, widht: 150 }}
                  value={checkProducts || ""}
                  onChange={(e) => handleCheckInput(e)}
                >
                  {() => (
                    <TextValidator
                      className={classes.textField}
                      name="checkProducts"
                      placeholder="# productos para distribuir"
                      validators={["required"]}
                      errorMessages={[
                        "El campo se encuentra vacio, escribir un número",
                      ]}
                      variant="outlined"
                    ></TextValidator>
                  )}
                </InputMask>
                {errorObject.showError && (
                  <FormHelperText>{errorObject.message}</FormHelperText>
                )}
              </FormControl>

              <Button
                color="primary"
                style={{ marginLeft: 10 }}
                variant="contained"
                className={classes.rightButton}
                type="submit"
                endIcon={<CheckCircleOutlineIcon color="secondary" />}
              >
                Seleccionar
              </Button>
            </div>
          </Grid>
        </ValidatorForm>
      </Grid>

      <ProductTableToolbar
        productsSelected={selected}
        title={""}
        label={" producto(s) seleccionados"}
      />
      <TableContainer style={{ marginTop: 20 }}>
        {accesoryProducts.filter(({ accesory }) => accesory.siteId != null)
          .length > 0 ? (
          <Table
            className={classes.table}
            size={"medium"}
            aria-label="collapsible table"
          >
            <TableHeadProduct
              numSelected={selected.length}
              headCells={headCellAccesoryProduct}
              onSelectAllClick={(e) =>
                setSelected(selectAllCheckbox(e, accesoryProducts, "accesory"))
              }
              rowCount={accesoryProducts.length}
            />
            <TableBody>
              {accesoryProducts
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((product, id) => {
                  return (
                    <AccesoryDetailRow
                      key={id}
                      selectedExam={selected}
                      row={product}
                      accesorySelected={handleClickCheckbox}
                      updateAccesories={handleActionTrigered}
                      productRemoved={handleActionTrigered}
                    ></AccesoryDetailRow>
                  );
                })}
            </TableBody>
          </Table>
        ) : (
          <Typography
            variant="h6"
            component="h4"
            style={{ marginTop: 50 }}
            className={classes.subtitle}
          >
            No se encontraron accesorios, agregar nuevo stock
          </Typography>
        )}
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={accesoryProducts.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={(event) => {
          const { rowsPerPage, page } = changeRowsPerPage(event);
          setRowsPerPage(rowsPerPage);
          setPage(page);
        }}
      />

      {openModal.open && openModal.option === 1 && (
        <DistributionDialog
          title="accesorios"
          open={openModal.open}
          onClose={handleOnClose}
          detailProduct={detailProduct}
          productsIdSelected={selected}
          productType="accesory"
        />
      )}

      {openModal.open && openModal.option === 2 && (
        <AddAccesoryStockModal
          onClose={handleOnClose}
          detailProduct={detailProduct}
          open={openModal.open}
          stockAdded={handleActionTrigered}
          isNewStock={accesoryProducts.every(
            ({ accesory }) => accesory.siteId !== null
          )}
        />
      )}

      {openModal.open && openModal.option === 3 && (
        <GlobalEdition
          open={openModal.open}
          onClose={handleOnClose}
          productsUpdated={handleActionTrigered}
          productsSelected={selected}
          productType={2}
          sizeProducts={accesoryProducts.length}
        />
      )}
    </Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(AccesoryDetail);
